import React, { useState, useEffect, useRef } from "react";
import "../user/Userinfo.scss";
import Card from "./Card";
import { Navigate, useNavigate } from "react-router-dom";
import { UserRolesEnum, UserRolesEnumLabels } from "../../enum/enums";
import PopInWindow from "../popInWindow/PopInWindow";
import UserProfile from "./UserProfile";
import ProfileIcon from "../../assets/icons/ProfileIcon";
import LogoutIcon from "../../assets/icons/LogoutIcon";
import defaultImage from "../../assets/images/default-profile.png";
const BASE_URL = process.env.REACT_APP_API_URL



const Userinfo = ({ onThemeToggle, onLogout }) => {
  const [imageSrc, setImageSrc] = useState('');
  const [userName,setUserName] =useState('');
  const [role,setRoleName] =useState('');
  const [viewDropdown, setViewDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const onReset  = () =>{
    navigate('../userprofile')
  }
  const getRoleName=(userRole)=>{
    return UserRolesEnumLabels[userRole]
  }
  const showHideDropdown = () => {
    setViewDropdown((prevState) => !prevState);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setViewDropdown(false);
    }
  };
  const loadUserData = () => {
    const user = localStorage.getItem("user");
    if (user) {
      try {
        const parsedUserData = JSON.parse(user);
        setImageSrc(BASE_URL + parsedUserData.profileImagePath);
        setUserName(parsedUserData.firstName + ' ' + parsedUserData.lastName);
        setRoleName(getRoleName(parsedUserData.userRole));
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  };
  useEffect(() => {    
    loadUserData();

    if (viewDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [viewDropdown]);



  const [ShowUserProfilePopin, setShowUserProfilePopin] = useState(false);
  const openUserProfilePopin = () => {
    setShowUserProfilePopin(!ShowUserProfilePopin);
  };  
  const handleViewClick = (row) => {
    //setEditingRow(row);
    setShowUserProfilePopin(!ShowUserProfilePopin);
    // showHideDropdown();
    setViewDropdown(false);
  };
  const handleProfileSave = () => {
    loadUserData(); // Reload user data after profile is saved
    setShowUserProfilePopin(false); // Close the profile pop-in
  };

  return (
    <div className="user-info" ref={dropdownRef}>
      <div className="user-info-wrapper" onClick={showHideDropdown}>
        <div className="left-info">
          <div className="img-area">
            <img className="user-image" src={imageSrc} alt="User" onError={(e)=> e.target.src=defaultImage}/>
          </div>
        </div>
        <div className="right-area">
          <div className="name">{userName}</div>
          <div className="position">{role}</div>
        </div>
      </div>
      {viewDropdown && (
        <div className="user-pop-up">
          <Card cardPadding={0}>
            <div className="user-details">
              <div className="mobile-info name">{userName}</div>
              <div className="mobile-info position">{role}</div>
            </div>
            {/* <button
              className="popup-list"
              onClick={() => {
                onThemeToggle();
                showHideDropdown();
              }}
            >
              <span className="zea-icons theme"></span> Switch Theme
            </button> */}
            <button className="popup-list" onClick={handleViewClick}>
              <span>
                <ProfileIcon/>
              </span>
                Profile
            </button>
            <button className="popup-list" onClick={onLogout}>
              <span>
                <LogoutIcon/>
              </span>
              Logout
            </button>            
          </Card>
        </div>
      )}
      {ShowUserProfilePopin && (
        <PopInWindow closePopin={handleViewClick}>
          <UserProfile
            onSave={handleProfileSave} // Pass callback to UserProfile
            closePopin={handleViewClick}
            //onButtonClick={handleEditClick}
          />
        </PopInWindow>
      )}
    </div>
  );
};

export default Userinfo;
